// src/pages/Admin.tsx
import React, { useContext, useEffect, useState } from 'react';
import { Container, Box, Typography, Button, Tabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import DocumentUpload from '../components/Admin/DocumentUpload';
import DocumentList from '../components/Admin/DocumentList';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const Admin = () => {
  const { isAuthenticated, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) return null;

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
            Panel de Administración
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="text" onClick={() => navigate('/')}>
              Volver al Chatbot
            </Button>
            <Button variant="outlined" onClick={logout}>
              Cerrar Sesión
            </Button>
          </Box>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="admin tabs">
            <Tab label="Lista de Documentos" />
            <Tab label="Subir Archivo" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <DocumentList />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <DocumentUpload />
        </TabPanel>
      </Box>
    </Container>
  );
};

export default Admin;